import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            {/* First Row */}
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Order Number"
                  className="py-2 mb-1"
                  {...register("orderNumber")}
                  isInvalid={!!errors.orderNumber}
                  maxLength={maxCharactersLength}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.orderNumber?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping Method"
                  className="py-2 mb-1"
                  {...register("shippingMethod")}
                  isInvalid={!!errors.shippingMethod}
                  maxLength={maxCharactersLength}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingMethod?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Second Row */}
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Carrier"
                  className="py-2 mb-1"
                  {...register("carrier")}
                  isInvalid={!!errors.carrier}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.carrier?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Tracking Number"
                  className="py-2 mb-1"
                  {...register("trackingNumber")}
                  isInvalid={!!errors.trackingNumber}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.trackingNumber?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Third Row */}
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping Cost"
                  className="py-2 mb-1"
                  {...register("shippingCost")}
                  isInvalid={!!errors.shippingCost}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingCost?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipped At"
                  className="py-2 mb-1"
                  {...register("shippedAt")}
                  isInvalid={!!errors.shippedAt}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippedAt?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Fourth Row */}
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Delivered At"
                  className="py-2 mb-1"
                  {...register("deliveredAt")}
                  isInvalid={!!errors.deliveredAt}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.deliveredAt?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping Status"
                  className="py-2 mb-1"
                  {...register("shippingStatus")}
                  isInvalid={!!errors.shippingStatus}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingStatus?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Shipping Address */}
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping Address Line 1"
                  className="py-2 mb-1"
                  {...register("shippingAddressLine1")}
                  isInvalid={!!errors.shippingAddressLine1}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingAddressLine1?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping Address Line 2"
                  className="py-2 mb-1"
                  {...register("shippingAddressLine2")}
                  isInvalid={!!errors.shippingAddressLine2}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingAddressLine2?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping City"
                  className="py-2 mb-1"
                  {...register("shippingCity")}
                  isInvalid={!!errors.shippingCity}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingCity?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping State"
                  className="py-2 mb-1"
                  {...register("shippingState")}
                  isInvalid={!!errors.shippingState}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingState?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping Postal Code"
                  className="py-2 mb-1"
                  {...register("shippingPostalCode")}
                  isInvalid={!!errors.shippingPostalCode}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingPostalCode?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Shipping Country"
                  className="py-2 mb-1"
                  {...register("shippingCountry")}
                  isInvalid={!!errors.shippingCountry}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.shippingCountry?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Billing Address */}
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Billing Address Line 1"
                  className="py-2 mb-1"
                  {...register("billingAddressLine1")}
                  isInvalid={!!errors.billingAddressLine1}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.billingAddressLine1?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Billing Address Line 2"
                  className="py-2 mb-1"
                  {...register("billingAddressLine2")}
                  isInvalid={!!errors.billingAddressLine2}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.billingAddressLine2?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Billing City"
                  className="py-2 mb-1"
                  {...register("billingCity")}
                  isInvalid={!!errors.billingCity}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.billingCity?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Billing State"
                  className="py-2 mb-1"
                  {...register("billingState")}
                  isInvalid={!!errors.billingState}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.billingState?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Billing Postal Code"
                  className="py-2 mb-1"
                  {...register("billingPostalCode")}
                  isInvalid={!!errors.billingPostalCode}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.billingPostalCode?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Billing Country"
                  className="py-2 mb-1"
                  {...register("billingCountry")}
                  isInvalid={!!errors.billingCountry}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.billingCountry?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
